<template>
  <div class="content">
    <!-- Nagłówek: Filtry (widoczny tylko jeśli NIE jest tryb wyniku) -->
    <!-- <h2
      v-if="!isResult"
      data-bs-toggle="collapse"
      :href="`#current-filters`"
      role="button"
      aria-expanded="true"
      :aria-controls="`current-filters`"
      class="margin-0"
    >
    {{ t('filters').toUpperCase() }}
    </h2> -->
    <!-- Przyciski nawigacji krokami -->
    <div class="d-flex justify-content-between actions">
      <label class="location-view-toggle" for="statistics-location-view-toggle" v-if="step === 1 && !isResult">
        <span class="toggle-label">{{ t('map').toUpperCase() }}</span>
        <input id="statistics-location-view-toggle" type="checkbox" v-model="useMapLocationList" />
        <span class="toggle-slider"></span>
      </label>
      <button class="btn-prev" v-if="step > 1" @click="previousStep()">
        <span>{{ t('back2').toUpperCase() }}</span>
      </button>
      <button class="btn-next ms-auto" v-if="step < 4 && !isResult" @click="nextStep()">
        {{ step === 3 ? "ZASTOSUJ" : "DALEJ" }}
      </button>
    </div>

    <!-- Sekcja filtrów: chowana/rozwijana collapse (Bootstrap/Manual) -->
    <div
      class="collapse"
      :class="hideFilters ? '' : 'show'"
      :id="`statistics-filters`"
    >
      <!-- Krok 1: wybór lokalizacji, daty, rozdzielczości -->
      <div v-if="step == 1">
        <div class="d-flex flex-column step-content step1">
          <preselect-tabs :store="filtersStore" />
          <div class="d-flex step2">
            <component :is="locationListComponent" :store="filtersStore" />
            <date-range
              :store="filtersStore"
              :dateTimeStart="filtersStore.filters.dateTimeStart"
              :dateTimeEnd="filtersStore.filters.dateTimeEnd"
              :disabled="filtersStore"
            />
            <resolution-filter style="width:40%;" :store="filtersStore" />
          </div>
        </div>
      </div>
      <!-- Krok 2: rodzaje naruszeń, kategorie pojazdów, pasy -->
      <div class="d-flex step-content step2 flex-wrap" v-else-if="step == 2 && !shouldHideLocation">
        <violation-list :store="filtersStore" />
        <vehicle-categories :store="filtersStore" :step="step" />
        <lane-numbers :store="filtersStore" :step="step" />
        <div class="break"></div>
      </div>
      <!-- Krok 3: agregacje/statystyka -->
      <div class="d-flex step-content step3" v-else-if="step == 3">
        <group-by-filter :store="filtersStore" />
        <graph-type-filter :store="filtersStore" />
      </div>
    </div>

    <!-- Widok wyniku (raport statystyk) -->
    <div v-if="isResult" class="content">
      <spinner-element :loading="loading" />
      <div
        v-for="(statsDataItem, index) in statData"
        :key="statsDataItem"
        id="statsData"
      >
        <!-- Przyciski powrotu i pobrania -->
        <div class="d-flex justify-content-between actions">
          <button class="btn-prev" @click="clear()">
            <span>{{ t('back2').toUpperCase() }}</span>
          </button>
          <button class="btn btn-download" :disabled="isDownloading" @click="retrieveZip()">
            <span>{{ t('download').toUpperCase() }}</span>
          </button>
        </div>
        <!-- Nazwa lokalizacji -->
        <h4 class="center-aligned">
          {{ statsDataItem.location.shortName }}
        </h4>
        <!-- Obrazek/statystyka (base64 img) -->
        <div class="center-aligned">
          <img v-bind:src="statImage[index]" class="img-fluid fitted-image" />
        </div>
        <div class="stats-data-wrapper">
          <!-- Tabela wynikowa (dane statystyczne) -->
          <table class="stats-data table table-striped">
            <thead class="thead-light">
              <tr>
                <th>{{ statsDataItem.labelPeriods }}</th>
                <th v-for="objectObj in statsDataItem.groups" :key="objectObj">
                  {{ objectObj.labelSeriesValue }}
                </th>
                <th>{{ t('sum') }}</th>
              </tr>
            </thead>
            <tbody v-if="statsDataItem.periods">
              <tr
                v-for="(period, index) in statsDataItem.periods"
                :key="period"
              >
                <td>{{ period.label }}</td>
                <th v-for="groupObj in statsDataItem.groups" :key="groupObj">
                  {{ groupObj.series[index].value }}
                </th>
                <td>{{ period.summary }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Ponowny przycisk powrotu -->
        <!-- <div class="d-flex justify-content-between actions">
          <button class="btn-prev" @click="clear()">
            <span>{{ t('back2').toUpperCase() }}</span>
          </button>
        </div> -->
        <hr/>
      </div>
    </div>
  </div>
</template>

<script>
// Importy zależności – Pinia store, serwis API, podkomponenty filtrów, spinnera itd.
import { useStatisticFiltersStore } from "../stores/statisticFilters";
import Statistics from "../services/Statistics";
import LocationList from "./filters/LocationList.vue";
import LocationList2 from "./filters/LocationList2.vue";
import DateRange from "./filters/DateRange.vue";
import LaneNumbers from "./filters/LaneNumbers.vue";
import VehicleCategories from "./filters/VehicleCategories.vue";
import ViolationList from "./filters/ViolationList.vue";
import PreselectTabs from "./statistics/PreselectTabs.vue";
import ResolutionFilter from "./statistics/ResolutionFilter.vue";
import moment from "moment";
import SpinnerElement from "./SpinnerElement.vue";
import GroupByFilter from "./statistics/GroupByFilter.vue";
import GraphTypeFilter from "./statistics/GraphTypeFilter.vue";
import { computed } from "vue";
import { isSG } from "@/config/appVersion";

// Ustaw język moment.js na polski
moment.locale("pl");

export default {
  // Podpięcie wszystkich podkomponentów używanych w szablonie
  components: {
    LocationList,
    LocationList2,
    DateRange,
    LaneNumbers,
    VehicleCategories,
    ViolationList,
    PreselectTabs,
    ResolutionFilter,
    SpinnerElement,
    GroupByFilter,
    GraphTypeFilter,
  },
  name: "StatisticsData",
  props: ["step", "isResult"], // Otrzymuje obecny krok procesu oraz czy jesteśmy w trybie "wynik"
  setup() {
    // Użycie Pinia store dla filtrów statystyk (dostępny jako filtersStore)
    const filtersStore = useStatisticFiltersStore();
    const shouldHideLocation = computed(() => isSG);

    return { filtersStore, shouldHideLocation, isSG };
  },
  data() {
    return {
      error: null,
      isDownloading: false, // Czy trwa pobieranie ZIP
      hideFilters: false,   // Czy ukryć UI z filtrami (tryb wyniku)
      moment: moment,       // Instancja moment.js do użycia w szablonie
      statGraph: [],        // Dane wykresów/statystyk dla lokalizacji
      statImage: [],        // Obrazki base64 (jako string do <img src=...>)
      useMapLocationList: false,
    };
  },
  created() {
    // Jeśli zmieni się liczba wybranych lokalizacji – przefiltruj dane
    this.$watch(
      () => this.filtersStore.filters.locations?.length,
      () => {
        this.runChangedLocations(this.filtersStore.filters.locations);
      }
    );
    // Jeśli zmieni się liczba właściwości filtrów – wyczyść wynik (wróć do filtrów)
    this.$watch(
      () => Object.keys(this.filtersStore.filters).length,
      () => {
        this.runChangedFilters(this.filtersStore.filters);
      }
    );
  },
  watch: {
    isResult: function (newVal) {
      if (newVal === true) {
        this.retrieveGraph();
      }
    },
  },
  computed: {
    // Getter do wyciągnięcia tabeli danych do template
    statData() {
      return this.statGraph;
    },
    locationListComponent() {
      return this.useMapLocationList ? "LocationList2" : "LocationList";
    },
  },
  methods: {
    // Pobierz z backendu dane dla wykresu i statystyk
    retrieveGraph() {
      this.loading = true;
      this.hideFilters = true; // Schowaj filtry, pokaż spinner i potem wynik

      // Wyczyść poprzedni wynik – inaczej gdy nowe zapytanie zwróci mniej lokalizacji
      // niż poprzednie, stare wykresy zostają na końcu tablicy i renderują się poniżej.
      this.statGraph = [];
      this.statImage = [];

      // Wołamy serwis, dostajemy np. obiekty { location, periods, groups, graph: base64 }
      Statistics.getGraph()
        .then((data) => {
          this.loading = false;
          for (const graphs in data) {
            const statGraphData = data[graphs];
            // Dane statystyki (z backendu) pod dany indeks
            this.statGraph[graphs] = statGraphData;
            // Rysunek (img src) - zakładamy, że backend zwraca base64 jpeg!
            this.statImage[graphs] = "data:image/jpeg;base64," + statGraphData.graph;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.filtersStore.setErrors(error);
        });
    },

    // Pobieranie raportu ZIP z backendu (np. plik Excela/PDF ze statystykami)
    retrieveZip() {
      this.isDownloading = true;
      Statistics.getZip()
        .then((data) => {
          Statistics.fetch(data.link)
            .then((response) => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(response);
              link.download = "statistics";
              link.click();
              this.isDownloading = false;
              URL.revokeObjectURL(link.href);
            })
            .catch(console.error);
        })
        .catch((error) => {
          this.loading = false;
          this.filtersStore.setErrors(error);
        });
    },

    // Obsługa nawigacji między krokami
    nextStep() {
      // Jeżeli SG (shouldHideLocation) i jesteśmy na kroku 1 → pomiń 2 i leć na 3
      if (this.step === 1 && this.shouldHideLocation) {
        this.$emit('nextStep'); // 1 -> 2
        this.$emit('nextStep'); // 2 -> 3
      } else {
        this.$emit('nextStep');
      }
    },
    previousStep() {
      // Jeżeli SG i jesteśmy na kroku 3 → cofnij o dwa (na 1)
      if (this.step === 3 && this.shouldHideLocation) {
        this.$emit('previousStep'); // 3 -> 2
        this.$emit('previousStep'); // 2 -> 1
      } else {
        this.$emit('previousStep');
      }
    },

    // Wyczyść dane/statystyki i wróć do widoku filtrów
    clear() {
      this.$emit("clear");
      this.hideFilters = false;
    },

    // Helper do obsługi kliknięcia w nagłówek filtrów (np. rozwiń/zwiń)
    clickFilters(event) {
      if (event.target.className !== "collapsed") {
        this.hideFilters = false;
      }
    },

    // Jeśli zmieniają się lokalizacje – przefiltruj dane na żywo (po stronie frontu)
    runChangedLocations(locations) {
      if (!this.isResult) {
        return;
      }
      if (!locations) {
        this.clear();
      } else {
        this.statGraph = this.statGraph.filter((item) =>
          locations.includes(item.location.id)
        );
      }
    },

    // Jeśli jakikolwiek inny filtr się zmienia – czyść dane
    runChangedFilters() {
      if (!this.isResult) {
        return;
      }
      this.clear();
    },
  },
};
</script>

<style scoped>

.btn {
  margin: 5px 10px 5px 0;
  background-color: #e0e0e0 !important;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
}

hr {
  margin: 0;
}

th,
td {
  border: 1px solid black;
}

.content,
.step-content {
  width: 100%;
  min-height: 485px;
}

.content h2 {
  position: relative;
  padding: 15px 20px;
  background-color: white;
  cursor: default;
}

.content h2::after {
  width: 22px;
  height: 18px;
  position: absolute;
  left: 120px;
  top: 20px;
  content: "";
  background: url("../assets/icons/filtry.png") no-repeat left top;
}

.step1 {
  width: 100%;
}

.step2 .violations {
  width: 285px;
  border-top: 1px solid #bfbfbf;
}

.step2 .vehicle-categories .category-table {
  background-color: red;
}

h3 {
  position: relative;
  padding: 10px 20px;
  background-color: white;
  border-top: 1px solid #b8b8b6;
}
h3 button {
  position: absolute;
  right: 30px;
  top: 7px;
  padding: 5px 15px 5px 25px;
}
h3 button::before {
  position: absolute;
  left: 5px;
  top: 5px;
  content: "";
  width: 30px;
  height: 20px;
  background: url("../assets/icons/pobierz.png") no-repeat left top;
}

h4 {
  font-size: 16px;
  margin-top: 1rem;
}

.actions {
  background-color: white;
}

.actions button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}

.location-view-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-left: 20px;
}

.toggle-label {
  font-size: 12px;
  font-weight: 700;
  color: #58585a;
  letter-spacing: 0.04em;
}

.location-view-toggle input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 999px;
  background-color: #cfd4da;
  transition: background-color 0.2s ease;
}

.toggle-slider::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  transition: transform 0.2s ease;
}

.location-view-toggle input:checked + .toggle-slider {
  background-color: #35c759;
}

.location-view-toggle input:checked + .toggle-slider::before {
  transform: translateX(20px);
}
.actions .btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  position: relative;
  color: #58585a;
}
.actions .btn-next:before {
  content: "";
  position: absolute;
  right: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/dalej.png") no-repeat left top;
}
.actions .btn-next:hover {
  color: black;
}
.actions .btn-next:hover:before {
  background: url("../assets/icons/dalej_over.png") no-repeat left top;
}
.actions .btn-prev {
  margin-left: 30px;
  padding: 8px 8px 8px 45px;
  position: relative;
  color: #58585a;
}
.actions .btn-prev:before {
  content: "";
  position: absolute;
  left: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}
.actions .btn-prev:hover {
  color: black;
}
.actions .btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}

.actions .btn {
  margin: 8px 15px 8px 0;
  background-color: #e0e0e0;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  font-weight: normal;
  padding: 0;
  border: 0;
  font-size: 12px;
}

.stats-data-wrapper {
  display: flex;
  justify-content: center;
  overflow-x: auto;
  width: 100%;
}

.stats-data {
  width: 95%;
  font-size: 12px;
  color: black;
  max-width: 1000px;
  overflow-x: auto;
  border-collapse: collapse;
}

/* wykres (img) ma się mieścić w dostępnej szerokości */
.fitted-image {
  display: block;
  margin: 0 auto 10px;   /* usuwa przesunięcie w lewo */
  max-width: 100% !important;
  width: 100%;
  height: auto;
  object-fit: contain;
}
/*.fitted-image {
//  margin-left: 70px;
//  max-width: none;
//  margin-bottom: 10px;
//} */

.step2 {
  width: 100%;
}

.actions .btn-download {
  border-radius: 4px;
}

.actions .btn-download:hover {
  background-color: #ccc !important;
}
</style>
